import { useSelector } from 'react-redux';
import { selectBreadcrumbs } from '../../selectors/breadcrumbs';
import { Breadcrumbs, BreadcrumbLinkButton, Breadcrumb } from '../../components/Breadcrumbs';
import * as React from 'react';
import { Responsive } from '@cian/ui-kit';

interface IBreadcrumbContainerProps {
  placement: 'header' | 'footer';
}

export const BreadcrumbsContainer: React.FC<IBreadcrumbContainerProps> = ({ placement }) => {
  const breadcrumbs = useSelector(selectBreadcrumbs);

  if (!breadcrumbs?.length) {
    return null;
  }

  return (
    <>
      <Responsive desktop tablet>
        {placement === 'header' && (
          <Breadcrumbs>
            {breadcrumbs.map((breadcrumb, key) => (
              <Breadcrumb key={key} {...breadcrumb} />
            ))}
          </Breadcrumbs>
        )}
      </Responsive>

      <Responsive phone>
        {placement === 'header' && (
          <Breadcrumbs>
            <BreadcrumbLinkButton {...breadcrumbs[breadcrumbs.length - 1]} />
          </Breadcrumbs>
        )}
        {placement === 'footer' && (
          <Breadcrumbs withBackground>
            {breadcrumbs.map((breadcrumb, key) => (
              <Breadcrumb key={key} {...breadcrumb} />
            ))}
          </Breadcrumbs>
        )}
      </Responsive>
    </>
  );
};
